import state from './roomSettingState'
import mutations from './roomSettingMutations'
import getters from './roomSettingGetters'
import actions from './roomSettingActions'

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}